import React, { useState } from 'react';
import FooterPageLayout from '../../components/layouts/FooterPageLayout';
import ChatbotModal from '../../components/PopUpModal/ChatbotModal';

const Support = () => {
  const [chatbotOpen, setChatbotOpen] = useState(false);
  const [formData, setFormData] = useState({
    category: 'Bug Report',
    feedback: '',
    email: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Feedback submitted:', formData);
    alert('Thank you for your feedback! We will review it and get back to you shortly.');
    setFormData({ category: 'Bug Report', feedback: '', email: '' });
  };

  return (
    <FooterPageLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-grey-900 mb-6">Support & Feedback</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-grey-900 mb-4">Help Center</h2>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="border rounded-lg p-4">
                  <h3 className="font-medium text-grey-900 mb-2">Getting Started</h3>
                  <ul className="space-y-2 text-grey-600">
                    <li>• Account Setup</li>
                    <li>• Platform Navigation</li>
                    <li>• Basic Features</li>
                  </ul>
                </div>
                <div className="border rounded-lg p-4">
                  <h3 className="font-medium text-grey-900 mb-2">Common Issues</h3>
                  <ul className="space-y-2 text-grey-600">
                    <li>• Login Problems</li>
                    <li>• Payment Issues</li>
                    <li>• Technical Difficulties</li>
                  </ul>
                </div>
                <div className="border rounded-lg p-4">
                  <h3 className="font-medium text-grey-900 mb-2">Resources</h3>
                  <ul className="space-y-2 text-grey-600">
                    <li>• User Guides</li>
                    <li>• Video Tutorials</li>
                    <li>• FAQs</li>
                  </ul>
                </div>
              </div>
            </section>
            
            <section>
              <h2 className="text-2xl font-semibold text-grey-900 mb-4">Submit Feedback</h2>
              <div className="bg-grey-50 rounded-lg p-6">
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-grey-700">Your Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="mt-1 block w-full rounded-md border-grey-300 shadow-sm focus:border-grey-500 focus:ring-grey-500 px-3 py-2 border"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="category" className="block text-sm font-medium text-grey-700">Feedback Category</label>
                    <select
                      id="category"
                      name="category"
                      value={formData.category}
                      onChange={handleInputChange}
                      className="mt-1 block w-full rounded-md border-grey-300 shadow-sm focus:border-grey-500 focus:ring-grey-500 px-3 py-2 border"
                    >
                      <option>Bug Report</option>
                      <option>Feature Request</option>
                      <option>General Feedback</option>
                      <option>Performance Issues</option>
                      <option>Other</option>
                    </select>
                  </div>
                  
                  <div>
                    <label htmlFor="feedback" className="block text-sm font-medium text-grey-700">Your Feedback</label>
                    <textarea
                      id="feedback"
                      name="feedback"
                      value={formData.feedback}
                      onChange={handleInputChange}
                      rows={4}
                      className="mt-1 block w-full rounded-md border-grey-300 shadow-sm focus:border-grey-500 focus:ring-grey-500 px-3 py-2 border"
                      placeholder="Tell us what you think..."
                      required
                    ></textarea>
                  </div>
                  
                  <button
                    type="submit"
                    className="bg-grey-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-grey-800"
                  >
                    Submit Feedback
                  </button>
                </form>
              </div>
            </section>
            
            <section>
              <h2 className="text-2xl font-semibold text-grey-900 mb-4">Contact Support</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="border rounded-lg p-6">
                  <h3 className="font-medium text-grey-900 mb-2">Email Support</h3>
                  <p className="text-grey-600 mb-4">For general inquiries and non-urgent support</p>
                  <a 
                    href="mailto:support@pebbletheapp.com" 
                    className="text-[#B22A2B] hover:underline font-medium"
                  >
                    support@pebbletheapp.com
                  </a>
                </div>
                <div className="border rounded-lg p-6">
                  <h3 className="font-medium text-grey-900 mb-2">Live Chat</h3>
                  <p className="text-grey-600 mb-4">AI-powered assistance available 24/7</p>
                  <button 
                    onClick={() => setChatbotOpen(true)}
                    className="bg-[#B22A2B] text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-[#8a2122]"
                  >
                    Start Chat
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <ChatbotModal open={chatbotOpen} handleClose={() => setChatbotOpen(false)} />
    </FooterPageLayout>
  );
};

export default Support; 